/**
 * Watermark overlay component for agent data protection.
 *
 * REQ D2-SEC-003: Semi-transparent watermark overlay displays the
 * logged-in agent's name diagonally across sensitive views as a
 * screenshot deterrent.
 *
 * Only renders when the logged-in user has the "agent" role.
 * Admin users see no watermark.
 */
import { useAuth } from "../../contexts/auth";

export function Watermark() {
  const { user } = useAuth();

  // D2-SEC-003: Only show watermark for agent role
  if (!user || user.role !== "agent") return null;

  const watermarkText = user.full_name || `${user.first_name} ${user.last_name}`.trim() || user.username;

  return (
    <div
      className="fixed inset-0 pointer-events-none z-[9999] overflow-hidden"
      aria-hidden="true"
      data-testid="watermark-overlay"
    >
      <div className="absolute inset-0" style={{ transform: "rotate(-30deg)" }}>
        {/* Generate a grid of watermark text */}
        {Array.from({ length: 12 }).map((_, rowIdx) => (
          <div
            key={rowIdx}
            className="flex gap-32 whitespace-nowrap"
            style={{
              marginTop: rowIdx === 0 ? "-100px" : "120px",
              marginLeft: rowIdx % 2 === 0 ? "-100px" : "60px",
            }}
          >
            {Array.from({ length: 8 }).map((_, colIdx) => (
              <span
                key={colIdx}
                className="text-xl font-medium select-none"
                style={{
                  color: "rgba(192, 57, 43, 0.06)",
                  userSelect: "none",
                  WebkitUserSelect: "none",
                }}
              >
                {watermarkText}
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
